import sdkInstanceProvider from "../../providers/sdkInstanceProvider";
import savedItemsSdkProvider from "../../providers/savedItemsSdkProvider";
import clientConfigurationProvider from "../../providers/clientConfigurationProvider";
import { ServiceError, SdkError } from "../errors";
import isServiceError from "./isServiceError";
import groupedInFlightCancellationFacade from "./groupedInFlightCancellationFacade";

const { cancelTokenExecutorFactory, makeRequestFactory } =
  groupedInFlightCancellationFacade();

export default async (itemId, variantId) => {
  const sdkInstance = await sdkInstanceProvider("savedItems");
  const { updateItemRequestTimeout } = clientConfigurationProvider();
  const { isRequestCancelled } = savedItemsSdkProvider();
  const cancelInFlight = true;
  const cancellationGroup = itemId;
  const makeRequest = makeRequestFactory(cancellationGroup);
  const cancelTokenExecutor = cancelTokenExecutorFactory(cancellationGroup);

  try {
    const response = await makeRequest({
      cancelInFlight,
      request: () =>
        sdkInstance.updateItem({
          item: { itemId, variantId },
          requestOptions: {
            timeout: updateItemRequestTimeout,
            cancelTokenExecutor
          }
        })
    });

    return response;
  } catch (e) {
    if (isRequestCancelled(e)) {
      return null;
    }
    if (isServiceError(e)) {
      throw new ServiceError(e);
    }
    throw new SdkError(e);
  }
};
